import { Component, Inject, Input} from 'ng-metadata/core';
import { ChangeLangService } from '../../infra/lang/changeLang.service';
import { MappingTablesCache } from '../../mappingTablesCache/mappingTablesCache.service';
import {FavoritesService} from '../favorites.service';
import { FavoritesWarningMessageService } from './favoritesWarningMessage.service';
import {MediaQueries} from '../../infra/mediaQueries.service';
import { UserSessionManagerService } from '../../security/userSessionManager.service';
import {BriefResultService} from "../../search/briefResult/briefResult.service";


@Component({
    selector: "prm-favorites-warning-message",
    templateUrl: 'components/favorites/favoritesWarningMessage/favorites-warning-message.html',
})


export class PrmFavoritesWarningMessage{

    constructor(
      private favoritesWarningMessageService: FavoritesWarningMessageService,
      private userSessionManagerService: UserSessionManagerService,
      private mediaQueries: MediaQueries,
      private briefResultService: BriefResultService) {

    }

    ngOnInit(): void {
    }

    public close(){
      this.favoritesWarningMessageService.closeButton();
    }

    public onDismissByUser(){
      this.favoritesWarningMessageService.onDismissByUser();
    }

    public isDisplayToast(){
      return this.favoritesWarningMessageService.isDisplayToast();
    }

    get isFullViewOverlayOpen(){
        return this.briefResultService.isFullViewOverlayOpen;
    }


}





// WEBPACK FOOTER //
// ./src/main/webapp/components/favorites/favoritesWarningMessage/favoritesWarningMessage.directive.ts